import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from '../../styles/Building MGMT/CreateOffer.module.css';

const steps = ["Start", "Rent", "Fees", "Payment Timing", "Pets", "Policies", "Create"];

const API_BASE_URL = import.meta.env.VITE_API_URL;

const CreateOffer = ({unitId, onCancel, onSave, handleBack}) => {
  const [currentStep, setCurrentStep] = useState("Start");
  const [entryMethod, setEntryMethod] = useState(null);
  const navigate = useNavigate();
  const { buildingId } = useParams();
  const [rentAmount, setRentAmount] = useState('');
	const [securityDepositAmount, setSecurityDepositAmount] = useState('');
	const [applicationFee, setApplicationFee] = useState('');
	const [brokerFee, setBrokerFee] = useState('');
	const [firstMonthUpfront, setFirstMonthUpfront] = useState(true);
	const [lastMonthUpfront, setLastMonthUpfront] = useState(false);
	const [petsAllowed, setPetsAllowed] = useState(false);
	const [petRent, setPetRent] = useState('');
	const [petDeposit, setPetDeposit] = useState('');
	const [earlyTerminationPolicy, setEarlyTerminationPolicy] = useState('');
	const [customFees, setCustomFees] = useState('');


  const handleOptionSelect = (option) => {
    setEntryMethod(option);
    setCurrentStep("Rent");
  };

  const handleBackToUnits = () => {
    navigate(`/landlord/building/${buildingId}`);
  };
  
	const handleCreateOffer = async () => {
	  const landlordId = localStorage.getItem("landlordUserId");

	  const payload = {
		rentAmount: parseFloat(rentAmount),
		securityDepositAmount: parseFloat(securityDepositAmount) || 0,
		applicationFee: parseFloat(applicationFee) || 0,
		brokerFee: parseFloat(brokerFee) || 0,
		firstMonthUpfront,
		lastMonthUpfront,
		petsAllowed,
		petRent: parseFloat(petRent) || 0,
		petDeposit: parseFloat(petDeposit) || 0,
		earlyTerminationPolicy,
		customFees: customFees || null,
	  };

	  try {
		const res = await fetch(`${API_BASE_URL}/offers/landlord/${landlordId}/units/${unitId}/offers`, {
		  method: 'POST',
		  headers: {'Content-Type': 'application/json'},
		  credentials: 'include',
		  body: JSON.stringify(payload),
		});

		if (!res.ok) throw new Error('Failed to create offer.');

		const data = await res.json();
		onSave(data);
	  } catch (err) {
		alert('Failed to create offer: ' + err.message);
	  }
	};



  const renderCoverPage = () => (
    <div className={styles.coverContainer}>
      <button className={styles.coverOption} onClick={() => handleOptionSelect('prior')}>
        📋 Start from Prior Lease
      </button>
      <button className={styles.coverOption} onClick={() => handleOptionSelect('manual')}>
        ✍️ Enter Manually
      </button>
      <label className={styles.uploadBox}>
        📄 Upload Lease Document
        <input type="file" onChange={() => handleOptionSelect('upload')} />
      </label>
    </div>
  );

  const renderStepContent = () => {
    switch (currentStep) {
      case "Start":
        return renderCoverPage();
	case "Rent":
	  return (
		<div className={styles.stepContent}>
		  <label>Monthly Rent ($)</label>
		  <input 
			type="number" 
			placeholder="Monthly Rent"
			value={rentAmount}
			onChange={(e) => setRentAmount(e.target.value)}
		  />
		  <label>Security Deposit ($)</label>
		  <input 
			type="number" 
			placeholder="Security Deposit"
			value={securityDepositAmount}
			onChange={(e) => setSecurityDepositAmount(e.target.value)}
		  />
		</div>
	  );

	case "Fees":
	  return (
		<div className={styles.stepContent}>
		  <label>Signing Fees ($)</label>
		  <input 
			type="number" 
			placeholder="Signing Fees"
			value={brokerFee}
			onChange={(e) => setBrokerFee(e.target.value)}
		  />
		  <label>Application Fee ($)</label>
		  <input 
			type="number" 
			placeholder="Application Fee"
			value={applicationFee}
			onChange={(e) => setApplicationFee(e.target.value)}
		  />
		  <label>Custom Fees (optional)</label>
		  <input 
			type="text"
			placeholder="Description and Amount"
			value={customFees}
			onChange={(e) => setCustomFees(e.target.value)}
		  />
		</div>
	  );

	case "Payment Timing":
	  return (
		<div className={styles.stepContent}>
		  <label>First Month's Rent</label>
		  <select
			value={firstMonthUpfront ? "Due at Signing" : "Deferred"}
			onChange={(e) => setFirstMonthUpfront(e.target.value === "Due at Signing")}
		  >
			<option>Due at Signing</option>
			<option>Deferred</option>
		  </select>

		  <label>Last Month's Rent</label>
		  <select
			value={lastMonthUpfront ? "Due at Signing" : "Due at Last Month"}
			onChange={(e) => setLastMonthUpfront(e.target.value === "Due at Signing")}
		  >
			<option>Due at Last Month</option>
			<option>Due at Signing</option>
		  </select>
		</div>
	  );

	case "Pets":
	  return (
		<div className={styles.stepContent}>
		  <label>Pets Allowed?</label>
		  <select
			value={petsAllowed ? "Yes" : "No"}
			onChange={(e) => setPetsAllowed(e.target.value === "Yes")}
		  >
			<option>Yes</option>
			<option>No</option>
		  </select>

		  {petsAllowed && (
			<>
			  <label>Pet Rent ($)</label>
			  <input 
				type="number"
				placeholder="Pet Rent"
				value={petRent}
				onChange={(e) => setPetRent(e.target.value)}
			  />
			  <label>Pet Deposit ($)</label>
			  <input 
				type="number"
				placeholder="Pet Deposit"
				value={petDeposit}
				onChange={(e) => setPetDeposit(e.target.value)}
			  />
			</>
		  )}
		</div>
	  );

	case "Policies":
	  return (
		<div className={styles.stepContent}>
		  <label>Early Termination Policy</label>
		  <select
			value={earlyTerminationPolicy}
			onChange={(e) => setEarlyTerminationPolicy(e.target.value)}
		  >
			<option value="">Select Policy</option>
			<option value="Allowed">Allowed</option>
			<option value="Not Allowed">Not Allowed</option>
		  </select>
		</div>
	  );

      case "Create":
		  return (
			<button className={styles.createButton} onClick={handleCreateOffer}>
			  Create Offer
			</button>
		  );
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        {steps.map(step => (
          <button
            key={step}
            className={`${styles.stepButton} ${currentStep === step ? styles.activeStep : ''}`}
            onClick={() => setCurrentStep(step)}
          >
            {step}
          </button>
        ))}

        <button className={styles.backToUnitsButton} onClick={handleBack}>
          ← Back to Units
        </button>
      </div>

      <div className={styles.content}>
        {renderStepContent()}
      </div>
    </div>
  );
};

export default CreateOffer;
